<template>
  <div>
    <a-card size="small">
      <a-form>
        <g-dropdown label="Evaluaciones Disponibles"
                    :formItemConfig="fiOptions"
                    :cache="false"
                    endpoint="management_skill"
                    :selectedObj.sync="evaluacionSeleccionada"
        ></g-dropdown>
      </a-form>
    </a-card>
    <a-collapse accordion v-model="activeKey">
      <a-collapse-panel header="Empleado(s)" key="1" :disabled="panelPersonaDisabled">
        <g-master :endpoint="tablaEmpleados.endpoint"
                  :tableSetup="tablaEmpleados.tableSetup"
                  :actions="false">
        </g-master>
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Objetivos" key="1" v-if="$userIsInrol('VerOpcEvaDesemObjetivos')">
            <eva_objetivos v-if="idEmpSeleccionado" :id_emp="idEmpSeleccionado"></eva_objetivos>
            <span v-else>Seleccione un empleado para ver más.</span>
          </a-tab-pane>
          <a-tab-pane tab="Competencias" key="2" v-if="$userIsInrol('VerOpcEvaDesemCompetencias')">
            <eva_competencias v-if="idEmpSeleccionado" :id_emp="idEmpSeleccionado"></eva_competencias>
            <span v-else>Seleccione un empleado para ver más.</span>
          </a-tab-pane>
          <a-tab-pane tab="Identificación Potencial" key="3" v-if="$userIsInrol('VerOpcIdentificacionPotencial')">
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="Identificación de Potencial" key="1">
                <identificacion-personal v-if="idEmpSeleccionado" :id_emp="idEmpSeleccionado"></identificacion-personal>
                <span v-else>Seleccione un empleado para ver más.</span>
              </a-tab-pane>
              <a-tab-pane tab="Promoción o Traslado" key="2">
                <personal_prom_traslado v-if="idEmpSeleccionado" :id_emp="idEmpSeleccionado"></personal_prom_traslado>
                <span v-else>Seleccione un empleado para ver más.</span>
              </a-tab-pane>
            </a-tabs>
          </a-tab-pane>
        </a-tabs>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Objetivos from './Objetivos'
  import Competencias from './Competencias'
  import IdentificacionPersonal from './IdentificacionPersonal'
  import IdentificacionPersonalPromocionTraslado from './IdentificacionPersonalPromocionTraslado'

  export default {
    components: {Competencias, IdentificacionPersonal, IdentificacionPersonalPromocionTraslado, Objetivos},
    data () {
      return {
        activeKey: 0,
        activeEmpKey: 0,
        evaluacionSeleccionada: null,
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true,
          'class': 'evaluaciones'
        },
        loadingBtns: {},
        tablaEmpleados: {
          endpoint: 'consulta_team_gdp',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_emp'
            },
            allowSelect: true,
            selectedRows: [],
            actions: false,
            columns: [
              {title: 'ID Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Cedula', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre Empleado', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Fecha Ingreso', dataIndex: 'fecha_ingreso', sorter: true},
              {title: 'Jefe Inmediato', dataIndex: 'nombre_jefe', sorter: true}
            ]
          }
        },
        empleadoSeleccionado: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      normalizeRol (str) {
        if (!this.$isEmpty(str)) {
          return str.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        }
      }
    },
    computed: {
      panelPersonaDisabled () {
        return JsUtils.isEmpty(this.evaluacionSeleccionada)
      },
      idEmpSeleccionado () {
        return this.tablaEmpleados.tableSetup.selectedRows.length > 0 ? this.tablaEmpleados.tableSetup.selectedRows[0].id_emp : null
      }
    },
    watch: {
      evaluacionSeleccionada () {
        if (!JsUtils.isEmpty(this.evaluacionSeleccionada)) {
          this.activeKey = 1
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/Desempeno.vue